import React, { useState } from "react";
import "./Order_Summery_Holder2.css";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login_Modal from "../../../common-components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../../../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../../../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";

function Order_summery_holder2({ data, instock, isVendor }) {
  const navigate = useNavigate();

  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [error, setError] = useState("");
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleClick = () => {
    if (instock) {
      setError("Item is out of stock. Please try later.");
      return;
    }
    if (isVendor) {
    }

    if (data.data?.length > 0) {
      if (isSignIn) {
        if (isVendor) {
          const invalidProduct = data.data.find(
            (item) =>
              Number(item?.quantity) <
              Number(item?.Product_Variant?.b2b_min_quanity),
          );

          if (invalidProduct) {
            setError(
              `Minimum order quantity for ${invalidProduct.Product_Variant
                ?.Metal?.name || ""} is ${
                invalidProduct?.Product_Variant?.b2b_min_quanity
              }.`,
            );
            return;
          }
        }
        navigate("/proceed-to-Checkout");
      } else {
        setShowLoginModal(true);
        //  navigate("/proceed-to-Checkout");
      }
    } else {
      setError("Your cart is currently empty. Please add items to proceed.");
    }
  };

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  let total_amount = 0;
  let total_tax = 0;

  if (Array.isArray(data?.data)) {
    total_amount = data.data.reduce((acc, item) => {
      const tax_percentage = parseFloat(item?.Product?.tax_percentage || 0);
      let price = 0;
      if (!isVendor) {
        price = parseFloat(
          item?.Product_Variant?.price ||
            item?.Double_Variant?.price ||
            item?.Triple_Variant?.price ||
            0,
        );
      } else {
        price = parseFloat(
          item?.Product_Variant?.b2b_price ||
            item?.Double_Variant?.b2b_price ||
            item?.Triple_Variant?.b2b_price ||
            0,
        );
      }
      const qty = parseFloat(item?.quantity || 0);
      const line_total = price * qty;

      // Accumulate tax per item
      total_tax += line_total * (tax_percentage / 100);

      return acc + line_total;
    }, 0);
  }

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();

  return (
    <>
      <section className="Order_summery_holder2">
        {data.data?.length > 0 && (
          <div className="text_div">
            <div className="top_text">
              <p className="left_text">Subtotal</p>
              <p className="amount">
                {symbol} {Number(total_amount * rate).toFixed(2)}
              </p>
            </div>
            <p className="note_text">
              Taxes and shipping calculated at checkout
            </p>
          </div>
        )}

        <div className="btn_holder ">
          {data.data?.length > 0 && (
            <Green_btn btnText={"Checkout"} onClick={handleClick} />
          )}
          {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
        </div>
      </section>

      <Login_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        show={showSetPassModal}
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successful!"
      />
    </>
  );
}

export default Order_summery_holder2;
